import ScanTicket from './components'
import { reducer } from './reducers'

export { reducer }
export default ScanTicket
